import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cf5210a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-backdrop" }
const _hoisted_2 = {
  ref: "body",
  class: "modal-body",
  id: "modal-body"
}
const _hoisted_3 = { class: "modal-footer" }
const _hoisted_4 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "#center" }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_Transition, {
        appear: "",
        name: "slide-up"
      }, {
        default: _withCtx(() => [
          ($setup.showModal)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["modal", [$props.modalClass]]),
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "modal-title",
                "aria-describedby": "modal-body"
              }, [
                _createElementVNode("header", {
                  ref: "header",
                  class: "modal-header",
                  id: "modal-title"
                }, _toDisplayString($props.title), 513 /* TEXT, NEED_PATCH */),
                _createElementVNode("section", _hoisted_2, [
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                ], 512 /* NEED_PATCH */),
                _createElementVNode("section", _hoisted_3, [
                  _createElementVNode("footer", _hoisted_4, [
                    ($setup.hasCancelButton)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-cancel",
                          type: "button",
                          onClick: $setup.onClickCancelButton
                        }, _toDisplayString($props.cancelButtonTitle), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("button", {
                      ref: "okButton",
                      class: "btn btn-ok",
                      type: "button",
                      onClick: $setup.onClickOkButton
                    }, _toDisplayString($props.okButtonTitle), 513 /* TEXT, NEED_PATCH */)
                  ])
                ])
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true)
        ]),
        _: 3 /* FORWARDED */
      })
    ])
  ]))
}